import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  schemaAll: [],
  schema: {},
  currentPage: 1,
  totalPages: 1,
  rowsPerPage: 10,
  sortBy: "name",
  sortOrder: "asc",
};

const schemaSlice = createSlice({
  name: "schema",
  initialState,
  reducers: {
    setschemaAll: (state, action) => {
      state.schemaAll = action.payload;
    },
    setschema: (state, action) => {
      state.schema = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setTotalPages: (state, action) => {
      state.totalPages = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
  },
});

export const {
  setschemaAll,
  setschema,
  setCurrentPage,
  setTotalPages,
  setRowsPerPage,
} = schemaSlice.actions;

export default schemaSlice.reducer;
